import {
  LkPassport as Data,
  LkPassportCollection as Collection,
  LkPassportExtended,
  LkPassportExtendedCollection,
  PassportHistory,
  PassportTemplateType,
} from '@/typings/api/Passport'
import {
  BaseApiParams,
  BaseApiResponse,
  BaseApiResponseCollection,
} from '@/typings/common'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'

type BR = BaseApiResponse<Data>

type BRC = BaseApiResponseCollection<Data> & {
    data: Collection[];
}

export class LkPassportApi extends BaseLkApiAuth<
    Data,
    Collection,
    BaseApiParams,
    BR,
    BRC
    > {
    protected readonly endpoint = 'passport';

    public getPassports<P extends BaseApiParams>(rawParams?: P, config?: AxiosRequestConfig) {
      const path = ''
      const [url, params] = this.getUrl(path, rawParams)
      return this.request<BR, BRC>('GET', url, { params, ...config })
    }

    public getStatistics<P extends BaseApiParams>(rawParams?: P, config?: AxiosRequestConfig) {
      const path = '/statistics'
      const [url, params] = this.getUrl(path, rawParams)
      return this.request<BR, BRC>('GET', url, { params, ...config })
    }

    public getUserPassport<P extends BaseApiParams>(id: Data['id'], rawParams?: P, config?: AxiosRequestConfig) {
      const path = '/user'
      const [url, params] = this.getUrl(path, rawParams)
      return this.request<LkPassportExtended, LkPassportExtendedCollection>('GET', url, { params, ...config })
    }

    public getDetailedPassport<P extends BaseApiParams>(id: Data['id'], rawParams?: P, config?: AxiosRequestConfig) {
      const path = `/${id}`
      const [url, params] = this.getUrl(path, rawParams)
      return this.request<LkPassportExtended, LkPassportExtendedCollection>('GET', url, { params, ...config })
    }

    public updateContexts(id: Data['id'], data: Record<string, unknown>, config?: AxiosRequestConfig) {
      const path = `/${id}/update`
      const [url] = this.getUrl(path, data)
      return this.request('POST', url, { data, ...config })
    }

    public submitContexts(id: Data['id'], config?: AxiosRequestConfig) {
      const path = `/${id}/submit`
      const [url] = this.getUrl(path)
      return this.request('POST', url, { ...config })
    }

    public history<P extends BaseApiParams>(id: Data['id'], data: Record<string, unknown>, rawParams?: P, config?: AxiosRequestConfig) {
      const path = `${id}/history`
      const [url, params] = this.getUrl(path, rawParams)
      return this.request<never, PassportHistory[]>('POST', url, { data, params, ...config })
    }

    public downloadPrefill() {
      const path = 'download/prefill'
      const [url] = this.getUrl(path)
      return url
    }

    public uploadPrefill(file: File, ate_type: PassportTemplateType, config?: AxiosRequestConfig) {
      const path = 'upload/prefill'
      const [url] = this.getUrl(path)
      const data = new FormData()
      data.append('file', file)
      data.append('ate_type', ate_type)
      return this.request('POST', url, { data, ...config })
    }
}
